module.exports = __webpack_public_path__ + "img/index-title.bc6cd546.png";